
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment'
import { Product } from '../../models/products';

@Injectable({
    providedIn: 'root',
})
export class ProductsService {
    private _apiUrl = environment.apiUrl;
    private _http = inject(HttpClient);
    private _authHeaders = new HttpHeaders({
        Authorization: '',
    });

    public getProducts(): Observable<Product[]> {
        return this._http.get<Product[]>(`${this._apiUrl}/api/product/list`, {
            headers: this._authHeaders
        }).pipe(map((resp: any) => resp.data));
    }

}


